// extracted by mini-css-extract-plugin
export default {"techs":"ProjectPills_techs__SZxES","pill":"ProjectPills_pill__83TN-"};